import React from "react";
import Header from "../main-header/header";
import Footer from "../about/Footer";
import "./contact.css";

export default function Contact() {
  return (
    <div>
      <Header />
    <div className="contact-page">
      {/* Hero Section */}
      <header className="contact-hero">
        <h1>Contact VMAA Entertainment</h1>
        <p>We're ready to collaborate, create, and connect.</p>
      </header>

      {/* Contact Form */}
      <section className="contact-section">
        <form className="contact-form">
          <label>
            Name
            <input type="text" placeholder="Your Name" required />
          </label>
          <label>
            Email
            <input type="email" placeholder="Your Email" required />
          </label>
          <label>
            Message
            <textarea placeholder="Write your message..." rows="5" required></textarea>
          </label>
          <button type="submit">Send Message</button>
        </form>

        {/* Optional Map */}
      <div className="contact-map">
  <img
    src="images/map.jpg"
    alt="Map showing VMAA location"
    className="map-image"
  />
</div>
      </section>
     
    </div>
     <Footer />
    </div>
  );
}
